import { EditOutlined, MinusOutlined } from '@ant-design/icons';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { PlanSubtypes } from '@mm/state/interfaces/subscription';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import OveragesManagement from '../../OveragesManagement/OveragesManagement';

export const BillingUserLimit = ({
  subscription,
  facebookPage,
}: {
  subscription: SubscriptionModel;
  facebookPage: EnhancedBillingPage;
}) => {
  const { openBillingLimitsModal } = useModalActions();
  const diableOveragesManagementForFree2023Subs =
    subscription.planSubtypes?.includes(PlanSubtypes.free2023);
  return (
    <div className="billing-page-card__limit-options-wrapper">
      <OveragesManagement
        facebookPage={facebookPage}
        subscription={subscription}
        hideQuestionIcon
        className="billing-page-card__overages"
        disableOverages={diableOveragesManagementForFree2023Subs}
        textOverride="Automatically charge me for overages after current allotment is exceeded.
      You will receive an email and your credit card will be charged for each overage."
      />

      {/* <div className="billing-page-card__limit-wrapper">
        {' '}
        <div>
          Limit <MinusOutlined />                     //comment till BE is ready
        </div>{' '}
        <EditOutlined
          className="billing-page-card__edit-limit"
          onClick={() => openBillingLimitsModal({ subscription })}
        />{' '}
      </div> */}
    </div>
  );
};
